import Page from '@admin/components/page'
import Overview from './overview'
import Design from './design'
import React from 'react'

const mapPropsToPage = (props, context, resources, page) => ({
  title: resources.announcement.title,
  manager: {
    path: `/admin/truevail/admin/announcements/${resources.announcement.id}`,
    items: [
      {
        label: 't(Overview)',
        panel: <Overview announcement={ resources.announcement } />
      },
      {
        label: 't(Design)',
        path: '/design',
        panel: <Design announcement={ resources.announcement } />
      }
    ]
  }
})

const mapResourcesToPage = (props, context) => ({
  announcement: `/api/admin/truevail/admin/announcements/${props.params.id}`
})

export default Page(mapResourcesToPage, mapPropsToPage)
